import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import $javelink_api from "../../api/services/javelink_api";
import axios from "axios";
import {TOKEN, user_id} from "../../storage/user";
import $subscriptions_service_api from "../../api/services/subscriptions_service_api";


export const switchUserStatus = createAsyncThunk(
    "teams/switchUserStatus",
    async (subscription_service_id) => {
        try {
            const response = await $javelink_api.post(`/users/archive-team-member/`, {
                subscription_service_id: subscription_service_id
            });
            const {data, status} = response;

            return {data, status};
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const fetchAllUsers = createAsyncThunk(
    "teams/fetchUsers",
    async (params) => {
        try {
            const {data} = await $javelink_api.get("/users/get-team-members/?" + params);
            return data
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const fetchAllTeams = createAsyncThunk(
    "teams/fetchAllTeams",
    async () => {
        try {
            const {data} = await axios.get("https://api.wwa-ios.com/subscriptions/team/teams/my_teams/?page=1&page_size=1000", {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });
            return data
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const createTeam = createAsyncThunk(
    "teams/createTeam",
    async (team_name) => {
        try {

            const response = await axios.post("https://api.wwa-ios.com/subscriptions/team/teams/", {
                name: team_name
            }, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });


            const {data, status} = response

            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const removeTeam = createAsyncThunk(
    "teams/removeTeam",
    async (team_id) => {
        try {
            // const response = await $subscriptions_service_api.delete(`team/teams/${team_id}/`);

            const response = await axios.delete(
                `https://api.wwa-ios.com/subscriptions/team/teams/${team_id}/`, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });
            const {data, status} = response

            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const removeUserFromTeam = createAsyncThunk(
    "teams/removeUserFromTeam",
    async (subscription_service_id) => {
        try {
            const response = await $javelink_api.post("/users/delete-team-member/", {subscription_service_id}
            );

            const {data, status} = response

            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);


export const fetchTeamsWithParams = createAsyncThunk(
    "teams/fetchTeamsWithParams",
    async (params) => {
        try {
            const {data} = await axios.get("https://api.wwa-ios.com/subscriptions/team/teams/my_teams/?" + params, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            });

            return data
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const addUserToTeam = createAsyncThunk(
    "teams/addUserToTeam",
    async (form) => {

        try {
            const response = await $javelink_api.post("/users/add-team-member/", form);

            const {data, status} = response;

            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

export const editTeamName = createAsyncThunk(
    "teams/editTeamName",
    async ({team_id, team_name}) => {

        try {
            const response = await axios.patch(
                `https://api.wwa-ios.com/subscriptions/team/teams/${team_id}/update_name/`,
                {name: team_name},
                {
                    headers: {
                        Authorization: `Bearer ${TOKEN}`
                    }
                })

            const {data, status} = response;

            return {data, status}
        } catch (error) {
            const {data, status} = error.response;

            return {data, status};
        }
    },
);

const teamsSlice = createSlice({
    name: "teams",
    initialState: {
        usersList: [],
        usersListPending: false,
        switchUserStatusPending: false,
        allTeamsPending: false,
        allTeamsList: [],
        teamsWithParamsPending: false,
        teamsWithParamsList: [],
        addUserToTeamPending: false,
        editTeamNamePending: false,
        selectedTeamId: null,
        createTeamPending: false,
        excludedCurrentUser: null,
        removeTeamPending: false,
        removeUserFromTeamPending: false
    },
    reducers: {
        setSelectedTeamId: (state, action) => {
            state.selectedTeamId = action.payload;
        },

        setAllTeamsList: (state, {payload}) => {
            state.allTeamsList = [payload, ...state.allTeamsList];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(removeUserFromTeam.pending, (state) => {
                state.removeUserFromTeamPending = true;
            })
            .addCase(removeUserFromTeam.fulfilled, (state) => {
                state.removeUserFromTeamPending = false;
            })
            .addCase(removeUserFromTeam.rejected, (state) => {
                state.removeUserFromTeamPending = false;
            })

            .addCase(removeTeam.pending, (state) => {
                state.removeTeamPending = true;
            })
            .addCase(removeTeam.fulfilled, (state) => {
                state.removeTeamPending = false;
            })
            .addCase(removeTeam.rejected, (state) => {
                state.removeTeamPending = false;
            })

            .addCase(createTeam.pending, (state) => {
                state.createTeamPending = true;
            })
            .addCase(createTeam.fulfilled, (state) => {
                state.createTeamPending = false;
            })
            .addCase(createTeam.rejected, (state) => {
                state.createTeamPending = false;
            })

            .addCase(editTeamName.pending, (state) => {
                state.editTeamNamePending = true;
            })
            .addCase(editTeamName.fulfilled, (state, {payload}) => {
                state.editTeamNamePending = false;
            })
            .addCase(editTeamName.rejected, (state) => {
                state.editTeamNamePending = false;
            })

            .addCase(addUserToTeam.pending, (state) => {
                state.addUserToTeamPending = true;
            })
            .addCase(addUserToTeam.fulfilled, (state, {payload}) => {
                state.addUserToTeamPending = false;
            })
            .addCase(addUserToTeam.rejected, (state) => {
                state.addUserToTeamPending = false;
            })

            .addCase(fetchTeamsWithParams.pending, (state) => {
                state.teamsWithParamsPending = true;
                state.teamsWithParamsList = []
            })
            .addCase(fetchTeamsWithParams.fulfilled, (state, {payload}) => {
                state.teamsWithParamsPending = false;
                state.teamsWithParamsList = payload
            })
            .addCase(fetchTeamsWithParams.rejected, (state) => {
                state.teamsWithParamsPending = false;
                state.teamsWithParamsList = []
            })

            .addCase(fetchAllTeams.pending, (state) => {
                state.allTeamsPending = true;
                state.allTeamsList = []
            })
            .addCase(fetchAllTeams.fulfilled, (state, {payload}) => {
                state.allTeamsPending = false;
                state.allTeamsList = payload
            })
            .addCase(fetchAllTeams.rejected, (state) => {
                state.allTeamsPending = false;
                state.allTeamsList = []
            })

            .addCase(fetchAllUsers.pending, (state) => {
                state.usersListPending = true;
                state.usersList = []
            })
            .addCase(fetchAllUsers.fulfilled, (state, {payload}) => {
                    if (Array.isArray(payload)) {
                        const excluded = payload.find(team => team.id === user_id);

                        state.usersList = payload.filter(team => team.id !== user_id);

                        state.excludedCurrentUser = excluded || null;
                    } else {
                        state.usersList = [];
                        state.excludedCurrentUser = null;
                    }
                    state.usersListPending = false;
                })


            .addCase(fetchAllUsers.rejected, (state) => {
                state.usersListPending = false;
                state.subscriptionsList = []
            })

            .addCase(switchUserStatus.pending, (state) => {
                state.switchUserStatusPending = true;
            })
            .addCase(switchUserStatus.fulfilled, (state) => {
                state.switchUserStatusPending = false;
            })
            .addCase(switchUserStatus.rejected, (state) => {
                state.switchUserStatusPending = false;
            })
    },
});

export const {setSelectedTeamId, setAllTeamsList} = teamsSlice.actions;

export default teamsSlice.reducer;

export const teamsSelector = (state) => state.teams;